import { ApiResponse } from 'apisauce'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

import { Contact } from 'src/types'
import store from 'src/store'

Bugsnag.start({
  agent: false,
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
  appType: 'web',
  autoTrackSessions: false,
  onError(event: any) {
    const {
      me: { user }
    } = store.store.getState()

    const { id, name, email } = !user
      ? { id: '', name: '', email: '' }
      : {
          id: `${user.user_id}`,
          name: `${user.first_name} ${user.last_name}`,
          email: `${
            user.contacts.filter(
              ({ contact_type }: Contact) => contact_type === 'EMAIL'
            )?.[0]?.email_contacts?.[0]?.email || ''
          }`
        }

    event.setUser(id, email, name)
    return ['production', 'qa'].includes(process.env.REACT_APP_ENV)
  },
  plugins: [new BugsnagPluginReact()]
})

function clearMetadata() {
  Bugsnag.clearMetadata('Catch')
  Bugsnag.clearMetadata('Request')
  Bugsnag.clearMetadata('Response')
}

// apisauce - Monitor
export function webErrorsMonitor(response: ApiResponse<any>): void {
  /**
   * https://developer.mozilla.org/en-US/docs/Web/HTTP/Status
   *
   * Informational responses (100–199)
   * Successful responses (200–299)
   * Redirection messages (300–399)
   * Client error responses (400–499)
   * Server error responses (500–599)
   *
   * 401 Unauthorized
   */

  if (!response.status || response.status <= 399 || response.status === 401) {
    // its ok
    return
  }

  clearMetadata()

  if (response.config?.data) {
    try {
      Bugsnag.addMetadata('Request', {
        request: JSON.parse(response.config?.data || {})
      })
    } catch (error) {
      Bugsnag.addMetadata('Request', {
        request: 'error on parse',
        data: response.config?.data
      })
    }
  }

  Bugsnag.addMetadata('Response', { status: response.status })
  Bugsnag.addMetadata('Response', { duration: response.duration })
  Bugsnag.addMetadata('Response', { url: response.config?.url })
  Bugsnag.addMetadata('Response', { method: response.config?.method })
  Bugsnag.addMetadata('Response', { headers: response.config?.headers })
  Bugsnag.addMetadata('Response', { baseURL: response.config?.baseURL })

  Bugsnag.addMetadata('Response', { response: response.data })

  Bugsnag.notify(response.config?.url || 'webMonitor')
}

export function ClientNotifyCatch(caller: string, err: unknown): void {
  clearMetadata()
  Bugsnag.addMetadata('Catch', { err })
  Bugsnag.notify(caller)
}
